import {
  getAuthConnection,
  getFileAuthConnection,
  getAuthConnectionWithNoTimeOut,
} from "./config.js";
import { toParams } from "@/utils/index.js";
/*
export function getAPISample(query) {
  return getAuthConnection().get(`some-address${query}`);
}

export function postAPISample(data) {
  return getAuthConnection().post(`some-address`, data);
}

export function putAPISample(data) {
  return getAuthConnection().put(`some-address/${id}`, data);
}

export function delAPISample(id) {
  return getAuthConnection().delete(`some-address/${id}`);
}
*/

export function getFeatureProperties(id) {
  // Feature 내부 properties 에 대한 정보를 불러옴.
  return getAuthConnection().get(`item/${id}/column`);
}

export function getExtraProperties(id, key) {
  // Feature의 상세 properties 에 대한 정보를 불러옴.
  return getAuthConnection().get(`item/${id}/properties?key=${key}`);
}

export function getProperties(payload) {
  return getAuthConnection().get(`properties?${toParams(payload)}`);
}

export function postFeatures(id, data) {
  return getAuthConnection().post(`item/${id}/`, data);
}

export function delFeature(itemId, featureId) {
  return getAuthConnection().delete(`feature/${itemId}/${featureId}`);
}

export function putFeature(itemId, featureId, data) {
  return getAuthConnection().put(`feature/${itemId}/${featureId}`, data);
}

export function patchApt(id, data) {
  return getAuthConnection().patch(`apartment/${id}/`, data);
}

export function patchOfficetel(id, data) {
  return getAuthConnection().patch(`/officetel/${id}/`, data);
}

export function patchIndustrial(id, data) {
  return getAuthConnection().patch(`/industrial-geometry/${id}/`, data);
}

export function getFeatureFiles(itemId, featureId) {
  return getAuthConnection().get(`feature/files/${itemId}/${featureId}`);
}

export function postFeatureFiles(itemId, featureId, data) {
  const form = new FormData();

  Object.keys(data).forEach((key) => {
    form.append(key, data[key]);
  });
  return getFileAuthConnection().post(
    `feature/files/${itemId}/${featureId}`,
    form
  );
}

export function delFeatureFile(fileId) {
  return getAuthConnection().delete(`feature/files/${fileId}`);
}

export function getFile(url, returnObject = false) {
  return getAuthConnectionWithNoTimeOut()
    .get(url, { responseType: "blob" })
    .then((response) => {
      if (returnObject) {
        return response.data;
      }
      return URL.createObjectURL(response.data);
    });
}

export function postFiles(data) {
  const form = new FormData();

  data.forEach((file, idx) => {
    form.append(idx, file);
  });

  return getFileAuthConnection().post(`files`, form);
}

export function patchHouseConstructionPlan(id, data) {
  return getAuthConnection().patch(`houseconstructionplan/${id}/`, data);
}

export function getAddressCode(query) {
  return getAuthConnection().get(`address-code?${query}`);
}

export function exportLayer(data) {
  return getAuthConnectionWithNoTimeOut().post(`export/`, data);
}

export function exportFunction(data) {
  return getAuthConnectionWithNoTimeOut().post(`export/function`, data);
}

export function patchFeatureProperty(itemId, featureId, data) {
  return getAuthConnection().patch(`feature/${itemId}/${featureId}`, data);
}
